
import * as Yup from 'yup';

import { useState,forwardRef } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
  Link,
  Stack,
  TextField,
  IconButton,
  InputAdornment,
  Dialog, DialogTitle, DialogActions, DialogContentText, DialogContent,
  Button,
  Slide


} from '@mui/material';
import { LoadingButton } from '@mui/lab';


import { useAuth } from '../../customContextProviders/AuthContext';
import { AdminLogin } from '../../../network/User';
import AlertDialog from '../../AlertDialog';
import ConfirmAlertDialog from '../../ConfirmDialog';
import {parseValidationErrorMessage} from '../../../utils/Utilities'
import { APP_CONSTANTS } from '../../../URLConstants';

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LoginSchema = Yup.object().shape({
  // email: Yup.string().email('Email must be a valid email address').required('Email is required'),
  email: Yup.string().required('Email is required'),
  password: Yup.string().required('Password is required')
});




export default function LoginForm() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const {authenticateSession}=useAuth()

 

  const [errorData, setErrorData] = useState({
    visible: false,
    message: "",
    title:""
  })

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  const [confirmOpenAlertDialog, setConfirmOpenAlertDialog] = useState(false)
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: "",
    title: "",
    positiveBtnLable: "",
    negativeBtnLable: "",
    type: "",
    action: ""
  });

  const [additionalData, setAdditionalData]=useState({token:""})

  
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      remember: true
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      doLogin(formik.values.email, formik.values.password);
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;


  const handleAlertDialogClose = () => {
    setErrorData({ ...errorData, visible: false, message: "" })
  }


  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };



  function handleConfirmDialogPositiveClose(action) {

    switch (action) {
      case APP_CONSTANTS?.CUSTOM_ERROR_CODES?.PASSWORD_EXPIRED: {
        setConfirmOpenAlertDialog(false)
        navigate(`/resetpassword/${additionalData?.token}` )
        break;
      }
     
      default: {
        setConfirmOpenAlertDialog(false)
        break
      }

    }


  }

  function handleConfirmDialogNegativeClose() {
    setConfirmOpenAlertDialog(false)

  }


  function doLogin(email, password) {
    AdminLogin(email,password).then((res)=>{
      formik.setSubmitting(false)
      
      //MFA to be enabled only for BOB. Hence Validate OTP page is navigated when the code is running from anything other than common_dashboard environment
      if(process.env.REACT_APP_ENVIRONMENT !== "common_dashboard" && res?.data?.statusCode===201){ //
        navigate('/validateotp', { state:{userEmail:email}});
      }else{
        authenticateSession(res?.data?.data)
        navigate('/dashboard/soundboxT', { replace: true });
     }

 
    }).catch((error)=>{
      formik.setSubmitting(false)

      if(error?.response?.data?.customErrorCode=== APP_CONSTANTS?.CUSTOM_ERROR_CODES?.PASSWORD_EXPIRED){
        setAdditionalData(prevState => ({
          ...prevState,
          token: error?.response?.data?.validationErrors?.resetToken
        }));
        setConfirmAlertDialogMetas({ ...confirmAlertDialogMetas, message: "Your password has expired , please update now !", title: "Password Expired", positiveBtnLable: "YES", negativeBtnLable: "NO, CANCEL", alertType: "FAILURE", action: APP_CONSTANTS?.CUSTOM_ERROR_CODES?.PASSWORD_EXPIRED });
        setConfirmOpenAlertDialog(true)
        
      }else{
        setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error), title: "Failed to process your request", btnLabel: "OK" });
        setOpenAlertDialog(true)

      }

    })
  }



  return (
    <div>
      <FormikProvider value={formik}>
        <Form autoComplete="off"  noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              type="email"
              autoComplete="username"
              label="Email address"
              {...getFieldProps('email')}
              error={Boolean(touched.email && errors.email)}
              helperText={touched.email && errors.email}
            />

            <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              {...getFieldProps('password')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={Boolean(touched.password && errors.password)}
              helperText={touched.password && errors.password}
            />
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 3 }}>
            {/* <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label="Remember me"
          /> */}

            <Link component={RouterLink} variant="subtitle2" to="/forgetpassword">
              Forgot password?
            </Link>
          </Stack>

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            sx={{mt:3}}
          >
            Login
          </LoadingButton>
        </Form>
      </FormikProvider>

      <Dialog
        open={errorData?.visible}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleAlertDialogClose()}
        aria-describedby="iot_res_alert-dialog-slide-description"
      >
        <DialogTitle>{errorData?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="aiot_res_alert-dialog-slide-description">
            {errorData?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button onClick={() => handleAlertDialogClose()}>OK</Button>
        </DialogActions>
      </Dialog>

      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />

    <ConfirmAlertDialog
        openConfirmAlertDialog={confirmOpenAlertDialog}
        message={confirmAlertDialogMetas?.message}
        title={confirmAlertDialogMetas?.title}
        positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
        negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLable}
        action={confirmAlertDialogMetas?.action}
        handleClose={() => setConfirmOpenAlertDialog(false)}
        handleNegativeClose={() => handleConfirmDialogNegativeClose()}
        handlePositiveClose={(a) => handleConfirmDialogPositiveClose(a)}
        type={confirmAlertDialogMetas?.alertType}

      />


    </div>
  );
}
